import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ToastProvider } from './context/ToastContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import BottomNav from './components/BottomNav';
import Home from './pages/Home';
import Events from './pages/Events';
import EventDetail from './pages/EventDetail';
import styles from './App.module.css';

const App: React.FC = () => (
    <ToastProvider>
        <Router>
            <div className={styles.app}>
                <Navbar />
                <main className={styles.main}>
                    <Switch>
                        <Route path="/" exact component={Home} />
                        <Route path="/events" component={Events} />
                        <Route path="/event/:id" component={EventDetail} />
                    </Switch>
                </main>
                <Footer />
                <BottomNav />
            </div>
        </Router>
    </ToastProvider>
);

export default App;
